export const taxVerificationConfiguration = {
  fetchResultsMaxAttempts: 15,
  fetchResultsPollingInterval: 2000,
};
